import { render, staticRenderFns } from "./ProjectCreateBlock.vue?vue&type=template&id=25b46e03&scoped=true"
import script from "./ProjectCreateBlock.vue?vue&type=script&lang=js"
export * from "./ProjectCreateBlock.vue?vue&type=script&lang=js"
import style0 from "./ProjectCreateBlock.vue?vue&type=style&index=0&id=25b46e03&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b46e03",
  null
  
)

export default component.exports